export var UseMarkdownFor = /*#__PURE__*/ function(UseMarkdownFor) {
    UseMarkdownFor["none"] = "none";
    UseMarkdownFor["title"] = "title";
    UseMarkdownFor["detail"] = "detail";
    UseMarkdownFor["both"] = "both";
    return UseMarkdownFor;
}({});
